<template>
  <nav id="zhixin-nav" ref="header">
    <div class="navbar-top ">
      <!-- <div class="logo-wrap">
        <a class="navbar-brand" :href="mainUrl">
          <img src="@/assets/logo.png" class="nav-icon" alt="logo" />
        </a>
      </div> -->
      <div class="container">
        <div class="navbar-left">
          <ul class="nav navbar-nav navbar-left hidden-xs">
            <li class="course_learn_nav">
              <a :href="webHref" target="_blank">质心{{JIANGSAI}}</a>
            </li>
            <!-- <li class="forum_nav">
              <a href=" https://www.eduzhixin.com/#courses" target="_blank">在线学习</a>
            </li>
               <li>
              <a href="//forum.eduzhixin.com/" target="_blank">质心论坛</a>
            </li> -->
            <li class="app_nav btn-qr show">
              <div></div>
              <a :href="getMobileUrl" target="_blank">手机客户端</a>
            </li>
            <!-- <li>
              <a href="https://zt.eduzhixin.com/servicerule" target="_blank">收费项目和退款规则</a>
            </li> -->
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import utils from '@/utils/utils'
import { mapGetters } from 'vuex'

export default {
  name: 'Header',
  data () {
    return {
      JIANGSAI: process.env.VUE_APP_JIANGSAI,
      webHref: ''
    }
  },
  computed: {
    ...mapGetters(['mainUrl']),
    getMobileUrl () {
      if (utils.isAndroid()) {
        return 'https://sj.qq.com/myapp/detail.htm?apkName=com.eduzhixin.app'
      } else {
        return 'https://itunes.apple.com/cn/app/zhi-xin-zai-xian/id1157874179?mt=8'
      }
    }
  },
  created () {
    this.webHref = process.env.VUE_APP_ZHIXIN_URL
  }
}
</script>
<style  lang="scss">
  #zhixin-nav {
    .navbar-top {
      background: #3a3b3d;
      font-size: 12px;
      position: relative;

      .logo-wrap {
        position: absolute;
        left: 50%;
        margin-left: -15px;
        a {
          padding: 8px;
          img {
            width: 16px;
            height: 16px;
            margin-top: 7px;
          }
        }
      }

      .navbar-nav {
        list-style: none;
        li {
          float: left;
          position: relative;
          a {
            background-color: transparent;
            position: relative;
            padding: 0;
            height: 30px;
            line-height: 30px;
            margin: 0 15px;
            font-weight:400;
            color:rgba(191,192,193,1);
            text-decoration: none;
            border-bottom: 4px solid transparent;
          }

          &:first-child a{
            margin-left: 0;
          }
        }
        &:after,&:before {
          content: " ";
          display: block;
          clear: both;
        }
      }
      .btn-qr {
        div {
          content: '';
          display: none;
          position: absolute;
          background: url(../assets/img/qrcode.png) no-repeat;
          width: 178px;
          height: 178px;
          right: -45px;
          top: 30px;
          z-index: 99;
        }
        &.show:hover div {
          content: ' ';
          display: block
        }
      }
    }
  }
</style>
